module.exports = __webpack_public_path__ + "static/21-img-2-0f5317ba08c49e1d3f5120c9d7fae7ab.jpg";